<div class="comparetable__filter-wrapper">
  <form>

    <mat-form-field appearance="outline" subscriptSizing="dynamic"
                    class="formfield__no-label formfield__no-padding comparetable__sectionbaselines flex-fill"
                    [style.width.px]=400
                    [style.min-width.px]=400
                    floatLabel="never">
      <mat-select [formControl]="selectedSectionBaselines" multiple placeholder="Select topics to compare">
        <mat-option *ngFor="let sectionBaseline of filterSectionBaselines$|async" [value]="sectionBaseline.id">
          {{sectionBaseline.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <app-country-multi-select
      [formControl]="selectedCountries"
      [countries]="filterCountries$ | async"
      [label]="'Select countries to compare'"
      [showAllOption]="true"
      [subscriptSizing]="'dynamic'"
      [floatLabel]="'never'"
      class="formfield__no-label formfield__no-padding comparetable__country flex-fill"
      [style.width.px]=400
      [style.min-width.px]=400>
    </app-country-multi-select>

  </form>
</div>

<div class="compare__tablewrapper">
  <table mat-table [dataSource]="compareData$ | async">

    <ng-container *ngFor="let column of (columns$ | async)" [matColumnDef]="column.name">
      <th mat-header-cell *matHeaderCellDef>{{ column.name }}</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="column.name == 'Section'">{{ row.section }}</ng-container>
        <div [innerHTML]="row.row[column.iso2]"></div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="(columnHeaders$ | async)"></tr>
    <tr mat-row *matRowDef="let row; columns: (columnHeaders$ | async);"></tr>

  </table>
  <div *ngIf="!(compareData$ | async) " class="comparenotactive">
  Select sections and countries to compare from the dropdowns above.
  </div>
</div>
